import "moment/locale/fr.js";
import styles from "./Message.module.css";
import classNames from "classnames";
import { MessagesId, MsgType } from "cadendar-shared";
import { FaCheck, FaQuestion, FaRegHourglass } from "react-icons/fa";
import { IoIosWarning } from "react-icons/io";
import { BsFillPlayCircleFill, BsFillTelephoneForwardFill } from "react-icons/bs";
import {Button} from "@/components/ui/button";
import React from "react";

type AuthorType = "myself" | "team" | "caduser" | "otherTeam";

export interface MessageProps {
  id: MessagesId;
  posterName: string;
  seenByNames: string[];
  message: string;
  onMessageClick: () => void;
  displayAge: string;
  notSeenByMe: boolean;
  msg_type: MsgType;
  timestamp: Date;
  patient_name: string | null;
  onPatientNameClick: () => void;
  authorType: AuthorType;
  showRespondReplayButton?: boolean;
  onRespondReplayClick?: () => void;
}

const Message = (props: MessageProps) => {
  const {
    posterName,
    seenByNames,
    message,
    onMessageClick,
    displayAge,
    notSeenByMe,
    msg_type,
    patient_name,
    showRespondReplayButton,
  } = props;
  const seenComps =
    seenByNames && seenByNames.length > 0 ? (
      <span className={styles.message_age}>
        (vu par {seenByNames.reduce((str, name) => str + " " + name)})
      </span>
    ) : null;
  const icon =
    msg_type === "waiting" ? (
      <FaRegHourglass color="orange" />
    ) : msg_type === "done" ? (
      <FaCheck color="green" />
    ) : msg_type === "question" ? (
      <FaQuestion color="blue" />
    ) : msg_type === "urgent" ? (
      <IoIosWarning color="red" />
    ) : msg_type === "call" ? (
      <BsFillTelephoneForwardFill />
    ) : null;
  const withoutName = patient_name
    ? message.split(patient_name).map((str, i) => (
        <span className={styles.message_line} key={i}>
          {str}
        </span>
      ))
    : [<span className={styles.message_line}>{message}</span>];
  const nameComp = patient_name ? (
    <span className={styles.patient_name} onClick={props.onPatientNameClick}>
      {patient_name}
    </span>
  ) : null;
  const messageComp = (
    <>
      <span className={styles.icon}>{icon}</span>{" "}
      {withoutName.reduce(
        (acc, comp) =>
          acc === null ? (
            comp
          ) : (
            <>
              {acc}
              {nameComp}
              {comp}
            </>
          ),
        null as React.JSX.Element | null
      )}
    </>
  );
  return (
    <div
      className={classNames({
        [styles.message_not_seen]: notSeenByMe,
        [styles.emergency]: msg_type === "urgent",
      })}
      onClick={onMessageClick}
      data-testid={notSeenByMe ? "not_seen_message" : "seen_message"}
    >
      <span
        className={classNames(styles.user, {
          [styles.myself_color]: props.authorType === "myself",
          [styles.team_color]: props.authorType === "team",
          [styles.caduser_color]: props.authorType === "caduser",
          [styles.other_color]: props.authorType === "otherTeam",
        })}
      >
        {posterName} :{" "}
      </span>
      {messageComp}
      {showRespondReplayButton ? (
        <Button
          type="button"
          className={styles.respond_replay_button}
          title="Ouvrir le message vocal Respond"
          aria-label="Ouvrir le message vocal Respond"
          size="icon-xs"
          variant="ghost"
          onClick={(event) => {
            event.stopPropagation();
            props.onMessageClick();
            props.onRespondReplayClick?.();
          }}
        >
          <BsFillPlayCircleFill />
        </Button>
      ) : null}
      <span className={styles.message_age}> {displayAge}</span>
      <span> {seenComps}</span>
    </div>
  );
};

export default Message;
